const MuiDateCalendar = {
    defaultProps: {
        dayOfWeekFormatter: (day)=>day.slice(0, 2),
        showDaysOutsideCurrentMonth: true
    },
    styleOverrides: {
        viewTransitionContainer: {
            ['.MuiPickersSlideTransition-root']: {
                minHeight: '200px'
            }
        }
    }
};
export { MuiDateCalendar };

//# sourceMappingURL=date-calendar-overrides.js.map